import React, { useEffect } from 'react';
import { Form, Input, Button, Select } from 'antd';
import styles from './styles/agencySearchForm.scss';
import { AgencySyncStatus } from '../../../models';

// hours without a successful import after which an agent is listed as stale
export const STALE_OPTIONS = [
  { value: 24, label: 'Starija od 24 h' },
  { value: 72, label: 'Starija od 3 dana' },
  { value: 168, label: 'Starija od 7 dana' },
];

const AgencySearchForm = ({ onSubmit, className, form, initialValues }) => {
  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        email: initialValues.email,
        isActive: initialValues.isActive,
        syncStatus: initialValues.syncStatus,
        staleHours: initialValues.staleHours,
      });
    }
  }, [initialValues]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form.getFieldsValue());
  };

  const handleReset = () => {
    form.resetFields();
    onSubmit({});
  };

  return (
    <Form layout="inline" onSubmit={handleSubmit} className={`${styles.form} ${className}`}>
      <Form.Item>
        {form.getFieldDecorator('email')(
          <Input
            className={styles.email}
            placeholder={"E-mail"}
          />,
        )}
         
      </Form.Item>
      <Form.Item>
        {form.getFieldDecorator('isActive')(
          <Select placeholder={"Status"} style={{ width: 120 }}>
            <Select.Option value={null} key={0}>
              {"Status"}
            </Select.Option>
            <Select.Option value="true" key={1}>
              {"Aktivan"}
            </Select.Option>
            <Select.Option value="false" key={2}>
              {"Neaktivan"}
            </Select.Option>
          </Select>,
        )} 
      </Form.Item>
      <Form.Item>
        {form.getFieldDecorator('syncStatus')(
          <Select placeholder={"Status sinkronizacije"} style={{ width: 215 }}>
            <Select.Option value={null} key={0}>
              {"Status sinkronizacije"}
            </Select.Option>
            <Select.Option value={AgencySyncStatus.failed} key={1}>
              {"Neuspješno"}
            </Select.Option>
            <Select.Option value={AgencySyncStatus.success} key={2}>
              {"Uspješno"}
            </Select.Option>
          </Select>,
        )} 
      </Form.Item>
      <Form.Item>
        {form.getFieldDecorator('staleHours')(
          <Select placeholder={"Zadnja sinkronizacija"} style={{ width: 215 }} allowClear>
            {STALE_OPTIONS.map((option) => (
              <Select.Option value={option.value} key={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>,
        )}
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" className={styles.button}>
          {"Traži"}
        </Button>
      </Form.Item>
      <Form.Item>
        <Button onClick={handleReset} className={styles.button}>
          {"Resetiraj"}
        </Button>
      </Form.Item>
    </Form>
  );
};

AgencySearchForm.defaultProps = {
  className: '',
  initialValues: null,
};

export default Form.create()(AgencySearchForm);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageAgencyPage/AgencySearchForm.tsx